export const browseIdeas = [
  {
    id: 1,
    order: 1,
    authorId: '1',
    modifiedAt: '2025-03-30',
    title: 'Medieval Fortress Castle',
    generatorId: 'G-336',
  },
  {
    id: 2,
    order: 2,
    authorId: '2',
    modifiedAt: '2025-03-29',
    title: 'Armored Battle Mech',
    generatorId: 'G-244',
  },
  {
    id: 3,
    order: 3,
    authorId: '3',
    modifiedAt: '2025-03-25',
    title: 'Cozy Brick Cabin',
    generatorId: 'G-205',
  },
  {
    id: 4,
    order: 4,
    authorId: '3',
    modifiedAt: '2025-03-23',
    title: 'Assault Rifle',
    generatorId: 'G-206',
  },
  {
    id: 5,
    order: 5,
    authorId: '1',
    modifiedAt: '2025-03-22',
    title: 'Mage Staff',
    generatorId: 'G-169',
  },
  {
    id: 6,
    order: 6,
    authorId: '4',
    modifiedAt: '2025-03-21',
    title: 'Middle Ages House',
    generatorId: 'G-246',
  },
  {
    id: 7,
    order: 7,
    authorId: '5',
    modifiedAt: '2025-03-20',
    title: 'Battle Shield',
    generatorId: 'G-075',
  },
  {
    id: 8,
    order: 8,
    authorId: '6',
    modifiedAt: '2025-03-20',
    title: 'Modern Industrial Factory',
    generatorId: 'G-395',
  },
  {
    id: 9,
    order: 9,
    authorId: '7',
    modifiedAt: '2025-03-20',
    title: 'Fantasy Greatsword',
    generatorId: 'G-061',
  },
  {
    id: 10,
    order: 10,
    authorId: '8',
    modifiedAt: '2025-03-19',
    title: 'Cozy Patterned Bed',
    generatorId: 'G-199',
  },
];
